import React, { useState } from 'react';
import { Box, Card, CardContent, Typography, Grid, FormControlLabel, Switch, Divider, Select, MenuItem, Button } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../hooks/reduxHooks';
import { setTheme } from '../store/slices/themeSlice';
import { usePageMeta } from '../hooks/usePageMeta';

const Settings: React.FC = () => {
  usePageMeta('Settings – AskNow', 'Adjust your application preferences and theme.');
  const dispatch = useAppDispatch();
  const themeName = useAppSelector((s) => (s as any).theme.current) as 'dark' | 'ocean';
  const [pendingTheme, setPendingTheme] = useState<'dark' | 'ocean'>(themeName);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Configure your preferences
      </Typography>

      <Card>
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" gutterBottom>Theme</Typography>
              <Select
                size="small"
                value={pendingTheme}
                onChange={(e) => setPendingTheme(e.target.value as 'dark' | 'ocean')}
                sx={{ minWidth: 160 }}
              >
                <MenuItem value={'dark'}>Dark</MenuItem>
                <MenuItem value={'ocean'}>Ocean</MenuItem>
              </Select>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" gutterBottom>Notifications</Typography>
              <FormControlLabel control={<Switch defaultChecked />} label="Email notifications" />
            </Grid>
          </Grid>

          <Divider sx={{ my: 2 }} />
          <Box display="flex" gap={2}>
            <Button variant="contained" onClick={() => dispatch(setTheme(pendingTheme))}>Save</Button>
            <Button variant="outlined" onClick={() => setPendingTheme(themeName)}>Reset</Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Settings;


